import axios from "axios";
import { SagaIterator } from "redux-saga";
import { call, cancelled, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../http_client";

import {
  feedbacksChartFetchError,
  feedbacksChartFetchRequest,
  feedbacksChartFetchSuccess,
  feedbacksFetchError,
  feedbacksFetchRequest,
  feedbacksFetchSuccess,
} from "./actions";
import { FeedbacksActionTypes } from "./types";

export function* handleFeedbackFetch(action: ReturnType<typeof feedbacksFetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const { from, to, gateId, page, pageSize, market } = action.payload;
    const response = yield call(callGet, "/feedbacks/", { from, to, gateId, page, pageSize, market }, source.token);
    yield put(feedbacksFetchSuccess(response.data));
  } catch (err) {
    yield put(feedbacksFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

export function* handleFeedbackChartFetch(action: ReturnType<typeof feedbacksChartFetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const { from, to, gateId, market } = action.payload;
    const response = yield call(callGet, "/feedbacks/chart/", { from, to, gateId, market }, source.token);
    yield put(feedbacksChartFetchSuccess(response.data));
  } catch (err) {
    yield put(feedbacksChartFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

function* watchFeedbacksSagas(): SagaIterator {
  yield takeLatest(FeedbacksActionTypes.TABLE_FETCH_REQUEST, handleFeedbackFetch);
  yield takeLatest(FeedbacksActionTypes.CHART_FETCH_REQUEST, handleFeedbackChartFetch);
}

export default watchFeedbacksSagas;
